import React, { useEffect, useState } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CRow,
  CTableRow,
  CFormSelect,
  CFormLabel,
  CFormTextarea,
  CButton,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CHeaderNav,
  CButtonGroup,
  CTooltip,
  CLink,
} from '@coreui/react-pro'
import { Link, useNavigate, useParams } from 'react-router-dom'
import moment from 'moment'
import CIcon from '@coreui/icons-react'
import { cilInfo } from '@coreui/icons'

import ToastComponent from 'src/components/common/TaostComponent'
import ScorecardService from 'src/service/ScorecardService'
import ClubService from 'src/service/ClubService'
import Loader from 'src/components/Loader'
import CompleteMarkModal from './CompleteMarkModal'
import MarkAsCompleteModal from './MarkAsCompleteModal'

const FullScoreCard = () => {
  const navigate = useNavigate()
  const param = useParams()

  const [visible, setVisible] = useState(false)
  const [completMarkModalVisible, setCompletMarkModalVisible] = useState(false)
  const [finalScorecardModalVisible, setFinalScorecardModalVisible] = useState(false)

  const [scorecardDetails, setScorecardDetails] = useState([])
  const [scorecardColoumns, setScorecardColoumns] = useState([])
  const [fixtureDetails, setFixtureDetails] = useState({})
  const [statusValue, setStatusValue] = useState()
  const [loader, setLoader] = useState(true)
  const [gameDetails, setGameDetails] = useState({})

  const dropdownCol1 = [{ key: 'sc' }]
  const dropdownCol2 = [
    { key: 'hw' },
    { key: 'aw' },
    { key: 'al' },
    { key: 'hl' },
    { key: 'ssw' },
    { key: 'ssls' },
    { key: 'owt' },
    { key: 'bwm' },
    { key: 'blm' },
  ]

  const fetchData = async () => {
    setLoader(true)
    try {
      const res = await ScorecardService.fullScorecardDetail(param.fixtureId)
      if (res.status === 200) {
        setScorecardDetails(res.data)
        setFixtureDetails(res.fixtureDetails)
        setStatusValue(res.fixtureDetails.status)
        setScorecardColoumns(res.scorecardColoumns)
      }

      const clubRes = await ClubService.getClubDetails()
      console.log('clubRes', clubRes)
      if (clubRes.status === 200) {
        setGameDetails(clubRes.game_details)
        if (clubRes?.game_details?.game_type == 3) {
          navigate(`/indoor-full-scorecard/${param.fixtureId}`)
        } else {
          navigate(`/common-full-scorecard/${param.fixtureId}`)
        }
      }
    } catch (e) {
      ToastComponent('Something went wrong', 'error')
    } finally {
      setLoader(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleMatchStatus = (e) => {
    setStatusValue(e.target.value)
    const data = { fixtureId: param.fixtureId, status: e.target.value }

    if (e.target.value === '2') {
      ScorecardService.getSavedScorecardData(data).then((res) => {
        if (res.status === 200) {
          setCompletMarkModalVisible(true)
        }
      })
    } else {
      ScorecardService.changFixtureStatus(param.fixtureId, e.target.value)
        .then((res) => {
          ToastComponent(res.message, 'success')
        })
        .catch(() => ToastComponent('Something went wrong', 'error'))
    }
  }

  const formatFantasyPoints = (fp) =>
    fp % 1 !== 0 ? fp.toFixed(2).replace(/0+$/, '') : fp.toString()

  return (
    <>
      <CForm className="row g-3">
        <CRow>
          <CCol md={3}>
            <b>Round</b>: {fixtureDetails.round}
          </CCol>
          <CCol md={3}>
            <b>Team</b>: {fixtureDetails.team_name}
          </CCol>
          <CCol md={3}>
            <b>Start</b>: {moment(fixtureDetails.start_date).format('D.MM.YYYY')},{' '}
            {moment(fixtureDetails.start_time, ['HH:mm']).format('h:mma')}
          </CCol>
          <CCol md={3}>
            <b>End</b>: {moment(fixtureDetails.end_date).format('D.MM.YYYY')},{' '}
            {moment(fixtureDetails.end_time, ['HH:mm']).format('h:mma')}
          </CCol>

          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader>
                <strong>
                  {fixtureDetails.scorcard_link_url ? (
                    <Link to={fixtureDetails.scorcard_link_url} target="_blank">
                      Scorecard
                    </Link>
                  ) : (
                    'Scorecard'
                  )}
                </strong>
              </CCardHeader>

              <CCardBody>
                {loader ? (
                  <Loader />
                ) : (
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>PLAYER</th>
                          <th>
                            <CTooltip content="Position">
                              <CLink>POS</CLink>
                            </CTooltip>
                          </th>
                          <th>
                            <CTooltip content="Fantasy Points">
                              <CLink>FP</CLink>
                            </CTooltip>
                          </th>
                          {scorecardColoumns.map((col) => (
                            <th key={col.id}>
                              <CTooltip content={col.full_name}>
                                <CLink>{col.label}</CLink>
                              </CTooltip>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {scorecardDetails &&
                          scorecardDetails.map((item, rowIndex) => (
                            <CTableRow key={rowIndex}>
                              {/* PLAYER */}
                              <td
                                style={{
                                  position: 'sticky',
                                  left: 0,
                                  zIndex: 1,
                                  backgroundColor: '#f9f9f9',
                                  minWidth: '150px',
                                }}
                              >
                                {item.player_name}
                              </td>

                              {/* POSITION */}
                              <td>
                                {item.player_position === 1 && 'GPA'}
                                {item.player_position === 2 && 'GPB'}
                                {item.player_position === 3 && 'GPC'}
                                {item.player_position === 4 && 'GPD'}
                              </td>

                              {/* FANTASY POINTS */}
                              <td>{formatFantasyPoints(item.fantasy_points)}</td>

                              {/* READ-ONLY SCORECARD COLUMNS */}
                              {scorecardColoumns.map((col) => {
                                const key = col.attribute_key
                                const value = item[key]

                                console.log('sdfsdfsdf', value)

                                // sc → numeric
                                if (dropdownCol1.some((d) => d.key === key)) {
                                  return <td key={key}>{value ?? 0}</td>
                                }

                                // hw, aw, al, hl, ssw, ssls, owt, bwm, blm → Yes / No
                                if (dropdownCol2.some((d) => d.key === key)) {
                                  return <td key={key}>{value == 1 ? 'Yes' : 'No'}</td>
                                }

                                // fallback (if backend adds new column later)
                                return <td key={key}>{value ?? '-'}</td>
                              })}
                            </CTableRow>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </CCardBody>
            </CCard>
          </CCol>

          <CCol xs={12}>
            <CCard>
              <CCardHeader>
                <strong>Match Status</strong>
              </CCardHeader>
              <CCardBody>
                <CFormLabel>Match Status</CFormLabel>
                <CButton color="danger" size="sm" onClick={() => setVisible(!visible)}>
                  <CIcon icon={cilInfo} />
                </CButton>
                <CFormSelect value={statusValue} onChange={handleMatchStatus}>
                  <option value={0}>Select</option>
                  <option value={1}>In-Progress</option>
                  <option value={2}>Completed</option>
                </CFormSelect>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CForm>

      {/* <CompleteMarkModal visible={visible} setVisible={setVisible} />
      <MarkAsCompleteModal
        completMarkModalVisible={completMarkModalVisible}
        setCompletMarkModalVisible={setCompletMarkModalVisible}
        fixtureId={param.fixtureId}
        finalScorecardModalVisible={finalScorecardModalVisible}
        setFinalScorecardModalVisible={setFinalScorecardModalVisible}
      /> */}
    </>
  )
}

export default FullScoreCard
